<template lang="pug">
  el-scrollbar.h-100
    div.w12.ma-auto
      div.navheight
        div.fl.logo
          el-image(:src="require('@/assets/image/logo.jpg')" fit="none" width="490" height="110px")
        div.fr.loginbtn
          div
            el-button(v-if="user && !(user.type==1 && user.checkstatus!=3)" size="mini" type="primary" @click="goto(menu[0].children?menu[0].children[0].name:menu[0].name)") 进入工作台
            template(v-else-if="user && user.type==1")
              el-button(v-if="user.checkstatus==1" type="text" @click="goto('/authentication')") 认证
              span(v-if="user.checkstatus==2") 待审核
              span(v-if="user.checkstatus==3") 认证通过
              span(v-if="user.checkstatus==4") 认证不通过
              router-link.blue--text(v-if="user.checkstatus==5" to="/authentication") 认证被驳回
            template(v-if="!user")
              el-button(type="primary" plain @click="goto('/register')") 免费注册
              el-button(type="primary" @click="goto('/login')") 立即登录
            template(v-else)
              span.mx-5 {{user.name}}
              el-button(type="text" @click="exit") 退出
    div.ma-auto.menubg
      div.w12.ma-auto.menuheight
        div.mainnav
          div.nav_menu3
            ul
              li
                a(@click="goto('/index')") 网站首页
              li
                a(@click="goto('/bidding')") 招标公示
              li
                a(@click="goto('/notice')") 中标通知
              li
                a(@click="goto('/materials')") 闲置咨询
              li
                a.navhover(@click="goto('/registerguide')") 注册指引
              li
                a(@click="goto('/moneyguide')") 报价指引
    div.ma-auto.listbg
      div.w12.ma-auto
        div.line_height
        div.list_top_title 您所在的位置：首页 > 供应商注册指引
        div.line_height
        div.list_bg_white
          div.line_height
          div.guide_title 供应商注册指引
          div.guide_sub_text 一、供应商账号注册
          div.guide_text 操作路径：登录www.jhsrm.com，点击界面右上角【免费注册】。
          div.guide_img
            el-image(:src="require('@/assets/image/register1.png')")
          div.guide_text 填写信息：注册手机号-公司名称-注册人姓名-账号密码-勾选注册协议-点击注册。
          div.guide_img
            el-image(:src="require('@/assets/image/register2.png')")
          div.guide_sub_text 二、供应商认证
          div.guide_text 操作路径：使用注册账号登录http://www.jianhuabm.com:7006/login，点击界面右上角【认证】按照提示进行供应商认证。
          div.guide_text 企业认证：用户是企业性质供应商，请选择上方左侧企业认证方式。
          div.guide_text 1、管理组织：想要与之合作的建华分公司，填写时先确定好管理组织。
          div.guide_text 2、企业工商信息如实填写，否则无法审核通过 。
          div.guide_text 3、信息填写完毕勾选同意建华建材认证协议后点击提交。
          div.guide_text 4、系统管理员审核注册信息。
          div.guide_img
            el-image(:src="require('@/assets/image/register3.png')")
          div.guide_img
            el-image(:src="require('@/assets/image/register4.png')")
          div.guide_img
            el-image(:src="require('@/assets/image/register5.png')")
          div.guide_text 个人认证：用户是个人性质供应商，请选择个人认证方式，个体名称为个人姓名+身份证后四位；如果是有登记店铺名称个体工商户从“企业认证”填写资料
          div.guide_text 进行认证。
          div.guide_text 1、管理组织：想要与之合作的建华分公司，填写时先确定好管理组织。
          div.guide_text 2、其他信息如实填写，否则无法审核通过。
          div.guide_text 3、信息填写完毕勾选同意建华建材认证协议后点击提交。
          div.guide_text 4、系统管理员审核注册信息。
          div.guide_img
            el-image(:src="require('@/assets/image/register6.png')")
          div.guide_img
            el-image(:src="require('@/assets/image/register7.png')")
          div.guide_text 在此页面选择感兴趣的物料分类，将默认为关注此物料分类的商机，用户也可以暂不设置。此页面设置完成后用户进入待审核状态，等待管理组织审核。
          div.guide_sub_text 三、注册审核通过后如下图登录建华电子采购平台。
          div.guide_img
            el-image(:src="require('@/assets/image/register8.png')")
          div.line_height
          div.line_height
          div.guide_button_width
            el-button.guide_button(v-if="!user" type="primary" @click="goto('/register')") 立即注册
            el-button.guide_button(v-if="user && user.type==1 && user.checkstatus==1" type="primary" @click="goto('/authentication')") 立即注册
            el-button.guide_button(v-if="user && user.type==1 && user.checkstatus==5" type="primary" @click="goto('/authentication')") 立即注册
            el-button.guide_button(v-if="user && !(user.type==1 && user.checkstatus!=3)" size="mini" @click="goto(menu[0].children?menu[0].children[0].name:menu[0].name)" type="primary") 立即注册
          div.line_height
          div.line_height
        div.line_height
    div.foot.min-w12
      div.w12.ma-auto
        div.fl.footleft
          div.footlefttitlezh 联系我们
          div.footlefttitleen Contact Us
          div.footlefttext.footleftico1 电话：0760-2218-8591
          div.mt-3.footlefttext.footleftico2 邮箱：jianhuazcb@jianhuabm.com
          div.mt-3.footlefttext.footleftico3 地址：建华建材（镇江）有限公司
          div.w-100.text-left
            a(href="https://www.jianhuabm.com/index.php/new/index/g/c/id/365.html" target="_blank")
              el-button.transparent.white--text 举报投诉
        div.fr.footright
          div.footlink
          ul
            li
              div.footrightimg
                img(:src="require('@/assets/image/code-jh.jpg')" width="130" height="130")
              div.footrighttext 建华建材公众号
            li
              div.footrightimg
                img(:src="require('@/assets/image/code-wjzt.jpg')" width="130" height="130")
              div.footrighttext 为己杂谈公众号
            li
              div.footrightimg
                img(:src="require('@/assets/image/code-app.jpg')" width="130" height="130")
              div(class="footrighttext") 建华建材APP
            li
              div.footrightimg
                img(:src="require('@/assets/image/code-lz.jpg')" width="130" height="130")
              div(class="footrighttext") 建华廉正
    div.foot-line 版权所有(C)建华建材（镇江）有限公司 本站采用 建华建材信息技术支持 <a href='https://beian.mps.gov.cn/#/query/webSearch'>苏公网安备32111102000427号 </a><a href='https://beian.miit.gov.cn'>苏ICP备2021054158号</a>
</template>
<script>
import countTo from "vue-count-to";
export default {
  components: {
    countTo,
  },
  filters: {
    filterDr (e) {
      return e.filter((data) => {
        return data.dr == 0;
      });
    },
  },
  data() {
    return {
      show: false,
      show1: false,
      show2: false,
      show3: false,
      show4: false,
      num: 1,
      data: [],
      data1: [],
      data2: [],
      count: 0,
      num1: 0,
      num2: 0,
      num3: 0,
      num4: 0,
      list: {
        page_num: 1,
        page_size: 10,
      },
      head: {},
      body: [],
    };
  },
  props: {
    billcode: {
      type: String,
      default: null
    },
  },
  methods: {
    go() {
      if (this.user) {
        if (this.user.role == 7) {
          if (this.user.checkstatus == 1) {
            this.$notify({
              message: "请先认证供应商",
              type: "error",
            });
            return;
          } else if (this.user.checkstatus == 3) {
            this.goto(
              this.menu[0].children
                ? this.menu[0].children[0].name
                : this.menu[0].name
            );
            return;
          } else {
            this.$notify({
              message: "您的资料正在审核或未通过，请耐心等待或重新提交",
              type: "error",
            });
            return;
          }
        } else {
          this.goto(
            this.menu[0].children
              ? this.menu[0].children[0].name
              : this.menu[0].name
          );
          return;
        }
      } else {
        this.$notify({
          message: "请先登录",
          type: "error",
        });
      }
    },
    // eslint-disable-next-line no-unused-vars
  },
  async mounted() {
    //this.onScroll();
    //window.addEventListener("scroll", this.onScroll, true);
    if (this.$route.hash) {
      document.getElementById(this.$route.hash.split("#")[1]).scrollIntoView();
    }
    //await this.$utils.sleep(2000);

  },
  //destroy() {
    //window.removeEventListener("scroll", this.onScroll);
  //},
  created () {
  },
};
</script>
<style scoped>

</style>
